<template>
  <div class="couponIndex couponAdd">
    <p class="pageTitle">{{!ruleForm.id?'添加优惠券':'编辑优惠券'}}</p>
    <div class="articleBox">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-row>
          <el-col :span="8">
            <div class="grid-content bg-purple-dark">
              <el-form-item label="优惠券ZH" prop="name" :rules="rules.name">
                <el-input placeholder="请输入优惠券中文名" v-model="ruleForm.name" class="inputW" width="200px" maxlength="15"></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple-dark">
              <el-form-item label="优惠券EN" prop="nameEn" :rules="rules.nameEn">
                <el-input placeholder="请输入优惠券英文名" v-model="ruleForm.nameEn" class="inputW" width="200px" maxlength="15"></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple-dark">
              <el-form-item label="优惠券类型" prop="type" :rules="rules.type">
                <el-select class="inputW" v-model="ruleForm.type" placeholder="请选择类型">
                  <el-option
                    v-for="item in typeOptions"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <div class="grid-content bg-purple-dark">
              <el-form-item label="使用范围" prop="limitProduct" :rules="rules.limitProduct">
                <el-select class="inputW" v-model="ruleForm.limitProduct" placeholder="请选择使用范围">
                  <el-option
                    v-for="item in stateOptions"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <el-form-item label="优惠券面值" prop="discountUsdt" :rules="rules.discountUsdt">
              <el-input placeholder="请输入优惠券面值(USDT)" v-model="ruleForm.discountUsdt" class="inputW" width="200px" type="text" @input="ruleForm.discountUsdt = String(ruleForm.discountUsdt).replace(/[^\d]/g,'')" maxlength="5"  ng-pattern="/[^a-zA-Z]/" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发放数量" prop="num" :rules="rules.num">
              <el-input placeholder="请输入发放数量(张)" v-model="ruleForm.num" class="inputW" width="200px" type="text" @input="ruleForm.num = String(ruleForm.num).replace(/[^\d]/g,'')" maxlength="5"  ng-pattern="/[^a-zA-Z]/" ></el-input>
            </el-form-item>
          </el-col>
          
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="每人限领" prop="limitNum" :rules="rules.limitNum">
              <el-input placeholder="请输入每人限领数量(张)" v-model="ruleForm.limitNum" class="inputW" width="200px" @input="ruleForm.limitNum = String(ruleForm.limitNum).replace(/[^\d]/g,'')"  ng-pattern="/[^a-zA-Z]/" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="限新用户" prop="onlyNewUser" :rules="rules.onlyNewUser">
              <el-select class="inputW" v-model="ruleForm.onlyNewUser" placeholder="选择是否限新用户领取">
                <el-option
                  v-for="item in userType"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="抵扣条件" prop="minPower" :rules="rules.minPower">
              <el-input placeholder="请输入抵扣条件(TiB)" v-model="ruleForm.minPower" class="inputW" width="200px" @input="ruleForm.minPower = String(ruleForm.minPower).replace(/[^\d]/g,'')"  ng-pattern="/[^a-zA-Z]/" maxlength="5"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="区域黑名单" prop="areaCodes">
              <el-select class="inputW" v-model="ruleForm.areaCodes" multiple  placeholder="选择区域黑名单">
                <el-option
                  v-for="item in countryList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="ruleForm.limitProduct">
            <el-form-item label="指定商品" prop="productIds" :rules="rules.productIds">
              <el-select class="inputW" v-model="ruleForm.productIds" multiple  placeholder="选择指定商品">
                <el-option
                  v-for="item in produtList"
                  :key="item.id"
                  :label="item.productName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" class="dateBox">
            <el-form-item label="领取时间" prop="dateOne">
              <el-date-picker
                v-model="ruleForm.dateOne"
                type="daterange"
                range-separator="至"
                :picker-options="pickerOptions"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>    
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="有效时间" prop="useDateType">
              <el-select class="inputW" v-model="ruleForm.useDateType" placeholder="请选择有效时间">
                <el-option
                  v-for="item in timeType"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" class="dateBox">
            <el-form-item label="固定日期" prop="incomeStartDate" v-if="ruleForm.useDateType&&ruleForm.useDateType==1">
              <el-date-picker
                v-model="ruleForm.dateTwo"
                type="daterange"
                range-separator="至"
                :picker-options="pickerOptions"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="有效天数" prop="useDay" :rules="rules.useDay" v-if="ruleForm.useDateType&&ruleForm.useDateType==2">
              <el-input placeholder="请输入有效天数" v-model="ruleForm.useDay" class="inputW" width="200px" maxlength="5"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="优惠券描述(中文)" prop="content" :rules="rules.description">
          <editor-bar v-model="ruleForm.description" :isClear="isClear" @change="change" v-if="editorIf"></editor-bar>
        </el-form-item>
        <el-form-item label="优惠券描述(英文)" prop="content" :rules="rules.descriptionEn">
          <editor-bar v-model="ruleForm.descriptionEn" :isClear="isClear" @change="change" v-if="editorIf"></editor-bar>
        </el-form-item>
      </el-form>
    </div>
    <div class="footerBox">
      <el-button type="primary" @click="onSubmit('ruleForm')">立即提交</el-button>
      <el-button @click="cancelFunc">取消</el-button>
    </div>
  </div>
</template>

<script>
import EditorBar from "../../components/wangEditor/index";
export default {
  data() {
    var checkNum = (rule, value, callback) => {
      if (value==='') {
        return callback(new Error('输入不能为空'));
      }else {
        if (value !=parseInt(value)) {
          callback(new Error('输入必须为正数'));
        } else {
          callback();
        }
      }
    };
    return {
      pickerOptions:{
        disabledDate(time) {
        //Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
            return time.getTime() < Date.now() - 8.64e7;
        }
      },
      isClear: false,
      ruleForm: {
        id: null,
        name: null,
        nameEn: null,
        type: null,
        limitProduct: null,
        discountUsdt: '1',
        num: '1',
        limitNum: '1',
        onlyNewUser: null,
        minPower: '1',
        dateOne: [],
        useDateType: null,
        areaCodes: null,
        productIds: [],
        useDateType: null,
        description: null,
        descriptionEn: null,
        useDay: null
      },
      rules: {
        name: [
          { required: true, message: "请输入名称", trigger: "blur" }
        ],
        nameEn: [
          { required: true, message: "请输入名称", trigger: "blur" }
        ],
        type: [
          { required: true, message: "请选择优惠券类型", trigger: "change" }
        ],
        limitProduct: [
          { required: true, message: "请选择适用范围", trigger: "change" }
        ],
        discountUsdt: [
          { required: true, message: "请输入优惠券面值", trigger: "blur" }
        ],
        num: [
          { required: true, message: "请输入发放数量", trigger: "blur" }
        ],
        limitNum: [
          { required: true, message: "请输入每人限领次数", trigger: "blur" }
        ],
        onlyNewUser: [
          { required: true, message: "请选择是否只限新用户领取", trigger: "change" }
        ],
        minPower: [
          { required: true, message: "请输入抵扣条件", trigger: "blur" }
        ],
        useDateType: [
          { required: true, message: "请选择有效时间", trigger: "change" }
        ],
        dateOne: [
          { required: true, message: "请选择领取时间", trigger: "change" }
        ]
      },
      typeOptions: [
        { name: "抵扣金额", value: "1" },
      ],
      stateOptions: [
        { name: "全场通用", value: false },
        { name: "指定商品", value:  true},
      ],
      timeType: [
        { name: "固定日期", value: '1' },
        { name: "有效天数", value: '2' },
      ],
      userType: [
        { name: "是", value: true },
        { name: "否", value: false },
      ],
      countryList: [],
      produtList: []
    };
  },
  components: { EditorBar },
  created() {
    this.editorIf=true
    this.getCountry()
    this.getTableList()
    if (this.$route.query.id) {
      this.ruleForm.id=this.$route.query.id
      this.getCouponFunc();
    }
  },
  methods: {
    async getTableList() {
      let res = await this.$http.productAllAvailable();
      if (res) {
        console.log(res)
        this.produtList = res.data
      }
    },
    async getCouponFunc() {
      let res = await this.$http.couponDetail({id:this.ruleForm.id});
      if (res) {
        console.log(res.data)
        this.ruleForm.name = res.data.name
        this.ruleForm.nameEn = res.data.nameEn
        this.ruleForm.type = res.data.type.toString()
        this.ruleForm.discountUsdt = res.data.discountUsdt
        this.ruleForm.limitNum = res.data.release.limitNum
        this.ruleForm.limitProduct = res.data.limitProduct
        this.ruleForm.num = res.data.release.num
        this.ruleForm.onlyNewUser = res.data.release.onlyNewUser
        this.ruleForm.minPower = res.data.minPower
        this.ruleForm.areaCodes = res.data.areaCodes?JSON.parse(res.data.areaCodes): null
        console.log(this.ruleForm.areaCodes)
        this.ruleForm.useDateType = res.data.release.useDateType.toString()
        this.ruleForm.description = res.data.description
        this.ruleForm.descriptionEn = res.data.descriptionEn
        this.$set(this.ruleForm, "dateOne", [ res.data.release.releaseStartDate, res.data.release.releaseEndDate]);
        if (this.ruleForm.limitProduct) {
          this.ruleForm.productIds = res.data.productIds?JSON.parse(res.data.productIds): null
          console.log(this.ruleForm.productIds)
        }
        if (res.data.release.useDateType==2) {
          this.ruleForm.useDay = res.data.release.useDay
        } else if (res.data.release.useDateType==1) {
          this.$set(this.ruleForm, "dateTwo", [ res.data.release.useStartDate, res.data.release.useEndDate]);
        }
        
      }
    },
    async getCountry() {
      let res = await this.$http.areaBlacklistLibrary();
      if (res) {
        this.countryList = res.data
      }
    },
    cancelFunc(){
      this.$router.push({name:'couponList'})
    },
    onSubmit(formName){
      let _this = this
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          _this.ruleForm.releaseStartDate = _this.ruleForm.dateOne[0]
          _this.ruleForm.releaseEndDate = _this.ruleForm.dateOne[1]
          if (_this.ruleForm.limitProduct) {
            if (_this.ruleForm.productIds.length<1) {
              this.$message.error('请选择指定商品');
              return false
            } else {
              _this.ruleForm.productIds = _this.ruleForm.productIds?JSON.stringify(_this.ruleForm.productIds): null
            }
          }
          if(Number(_this.ruleForm.limitNum)>Number(_this.ruleForm.num)) {
            console.log(Number(_this.ruleForm.limitNum)>Number(_this.ruleForm.num))
            this.$message.error('每人限领次数不能大于发放数量');
            return false
          }
          if (_this.ruleForm.useDateType==1) {
            if (_this.ruleForm.dateTwo) {
              _this.ruleForm.useStartDate = _this.ruleForm.dateTwo[0]
              _this.ruleForm.useEndDate = _this.ruleForm.dateTwo[1]
            } else {
              this.$message.error('请选择固定日期');
              return false
            }
          } else {
            if (!_this.ruleForm.useDay) {
              this.$message.error('请输入有效天数')
              return false
            }
          }
          _this.ruleForm.areaCodes = _this.ruleForm.areaCodes&&_this.ruleForm.areaCodes.length>0?JSON.stringify(_this.ruleForm.areaCodes): null
          let res 
          if (_this.ruleForm.id) {
            res = await this.$http.couponUpdate({..._this.ruleForm});
          } else {
            res = await this.$http.couponAdd({..._this.ruleForm});
          }
          if (res) {
            this.$message.success('操作成功！');
            this.$router.push({name:'couponList'})
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    change(){}
  }
};
</script>

<style scoped>
.pageTitle{
  margin: 20px 0;
}

</style>
<style >
.couponIndex .el-input__inner{
  width: 210px;
}
.couponIndex .dateBox .el-input__inner{
  width: 240px;
}
.couponIndex .dateBox .el-date-editor .el-range-separator{
  width: 10%;
}
/* .ms_box{
  width: 400px;
  height: 200px;
} */
</style>
